import { FirmarkMark } from "./FirmarkMark";

/** The wordmark block at the top of every auth/intake card — one component
 *  instead of five hand-copied inline-styled versions. */
export function AuthWordmark() {
  return (
    <div className="auth-wordmark">
      <span className="auth-brand-row">
        <FirmarkMark size={22} />
        <span className="brand-word">Firmark</span>
      </span>
      <span className="auth-product">Engineering Studio</span>
    </div>
  );
}
